import React from "react";
import { Phone, Clock, MapPin } from "lucide-react";
import { restaurantInfo } from "../data/mock";
import Reveal from "../components/Reveal";
import { useI18n } from "../data/i18n";

const DiamondDivider = () => (
  <div className="flex items-center justify-center gap-2 my-4">
    <div className="w-12 h-px bg-gradient-to-r from-transparent to-[#e4c590]"></div>
    <span className="diamond-mark"></span>
    <span className="diamond-mark opacity-60"></span>
    <span className="diamond-mark"></span>
    <div className="w-12 h-px bg-gradient-to-l from-transparent to-[#e4c590]"></div>
  </div>
);

const Reservation = () => {
  const { t } = useI18n();
  return (
    <div className="bg-[#0a0a0a] pt-32 pb-24 min-h-screen relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <Reveal direction="up">
          <p className="section-label">{t("res.book_with_us")}</p>
          <h1 className="display text-5xl md:text-7xl text-[#f5f0e6] mt-3 mb-2">{t("res.title")}</h1>
          <DiamondDivider />
          <p className="text-[#cfc7b8] italic text-lg mb-12">{t("res.only_phone")}</p>
        </Reveal>
        <Reveal direction="up" delay={200}>
          <div className="bg-[#0f0f0f] border border-[#1f1f1f] p-10 lg:p-16 mb-12">
            <Phone size={48} className="text-[#e4c590] mx-auto mb-6" />
            <p className="text-[#cfc7b8] mb-4">{t("res.call_to_reserve")}</p>
            <a href={`tel:${restaurantInfo.phone}`} className="cb-btn cb-btn-gold inline-block text-base">
              <span className="cb-btn-text cb-btn-text-1">{restaurantInfo.phone}</span>
              <span className="cb-btn-text cb-btn-text-2" aria-hidden="true">{restaurantInfo.phone}</span>
            </a>
            <p className="text-[#7a7468] text-sm mt-4">{t("res.click_to_call")}</p>
          </div>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          <Reveal direction="left" delay={300}>
            <div className="bg-[#0f0f0f] border border-[#1f1f1f] p-8 h-full">
              <Clock size={28} className="text-[#e4c590] mx-auto mb-4" />
              <h3 className="text-[#e4c590] uppercase tracking-widest text-xs mb-3">{t("res.hours_label")}</h3>
              <p className="text-[#f5f0e6]">{t("common.reservation_hours")}</p>
            </div>
          </Reveal>
          <Reveal direction="right" delay={400}>
            <div className="bg-[#0f0f0f] border border-[#1f1f1f] p-8 h-full">
              <MapPin size={28} className="text-[#e4c590] mx-auto mb-4" />
              <h3 className="text-[#e4c590] uppercase tracking-widest text-xs mb-3">{t("res.location")}</h3>
              <p className="text-[#f5f0e6]">{t("contact.street")}</p>
              <p className="text-[#cfc7b8]">{t("contact.city")}</p>
            </div>
          </Reveal>
        </div>
        <Reveal direction="fade" delay={500}>
          <p className="text-[#a8a297] text-sm">{t("res.group_note")}</p>
        </Reveal>
      </div>
    </div>
  );
};

export default Reservation;
